import config from "@/utils/config";
import questionOnly from "./questionOnly";

import api from "./api";
import { Dialog, Toast } from "vant";
import store from "../store";
import router from "../router";
import { encrypt, decrypt } from './crypto'

//获取本地缓存的token
export const getToken = () => {
  let token = localStorage.getItem("token") || config.TOKEN;
  return token;
  return "";
};

export function isIos() {
  var equipmentType = "";
  var agent = navigator.userAgent.toLowerCase();
  var iphone = agent.indexOf("iphone");
  var ipad = agent.indexOf("ipad");
  if (iphone != -1 || ipad != -1) {
    equipmentType = "ios";
    return true;
  } else {
    return false;
  }
}

export function getPc() {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    var iosVer = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (iosVer) iosVer = parseInt(iosVer[1], 10);
    if (isWeixin) {
      // 还要判断ios和安卓版本。。。
      var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      if (
        compareVersion(wechatInfo[1], "7.0.14") == 1 &&
        ((iosVer && iosVer > 11) || !iosVer)
      ) {
        return 2;
      }
      return 3;
    } else {
      return 1;
    }
  } else {
    // pc
    return 0;
  }
}

export function compareVersion(v1, v2) {
  v1 = v1.split(".");
  v2 = v2.split(".");
  var len = Math.max(v1.length, v2.length);
  while (v1.length < len) {
    v1.push("0");
  }
  while (v2.length < len) {
    v2.push("0");
  }
  for (var i = 0; i < len; i++) {
    var num1 = v1[i];
    var num2 = v2[i];
    let max = Math.max(num1.length, num2.length);
    num1 = Math.pow(10, max - num1.length + 1) * num1;
    num2 = Math.pow(10, max - num2.length + 1) * num2;
    if (num1 * 1 > num2 * 1) {
      return 1;
    } else if (num1 * 1 < num2 * 1) {
      return -1;
    }
  }
  return 0;
}

var jumping = false;
export const jumpWxAuth = () => {
  if (!isWeixin()) return;
  if (jumping) {
    return;
  }
  jumping = true;
  const currentUrl = window.location.href;
  let url = urlencode(currentUrl);
  const code = getQueryString("code");
  const msg_type = getQueryString("msg_type");
  if (msg_type && msg_type > 0) {
    localStorage.setItem("msg_type", msg_type);
  }
  if (!code) {
    const authUrl = config.wx_auth_url
      .replace("#{{appid}}", getAppid())
      .replace("#{{url}}", url);
    jumping = false;
    window.location.href = authUrl;
  } else {
    let parm = {
      code: code
      // source: 'h5_temp'
    };
    return new Promise((resolve, reject) => {
      questionOnly
        .post(api.question.login, parm)
        .then(res => {
          if (res.sta == 0) {
            config.TOKEN = res.data.access_token;
            localStorage.setItem("token", res.data.access_token);
            handleZI(res.data.mp_openid)
            resolve();
            // 如果登录成功就重新进页面
            // let _url = window.location.href;
            // let baseUrl = _url.split("?");
            // let routerArr = _url.split("#");
            // let routerPath = routerArr[routerArr.length - 1];
            // if (routerPath.indexOf("question") > -1) {
            //   resolve();
            // }
            let _url = window.location.href;
            let baseUrl = _url.split("?");
            let routerArr = _url.split("#");
            let routerPath = routerArr[routerArr.length - 1];
            window.location.href = baseUrl[0] + "#" + routerPath;
          } else if (data.sta == -1) {
            alert(res.msg);
          }
          jumping = false;
        })
        .catch(function(errors) {
          jumping = false;
        });
    });
  }
};

export const configApi = async (success, error) => {
  let url = window.location.href.split("#")[0];
  // if (getQueryString("code") && url.indexOf("cert.xiaoxiaodati.com") < 0) {
  //   return;
  // } else {
  let parm = {
    access_token: "",
    url,
    source: "h5"
  };
  questionOnly
    .post(api.question.getSign, parm)
    .then(res => {
      if (res.sta == 0) {
        wx.config({
          debug: false,
          appId: getAppid(),
          timestamp: res.data.timestamp,
          nonceStr: res.data.noncestr,
          signature: res.data.sign,
          jsApiList: [
            "chooseWXPay",
            "wx-open-launch-weapp",
            "chooseImage",
            "previewImage"
          ],
          openTagList: ["wx-open-launch-weapp"]
        });
        wx.ready(function(res) {
          success && success();
        });
        wx.error(function(res) {
          alert("config err:" + JSON.stringify(res));
          error && error(res);
        });
      }
    })
    .catch(function(errors) {
      alert("errors" + errors);
    });
  // }
};

export const checkWxConfig = () => {
  if (!isWeixin()) return;
  // 注册wx.config的回调函数
  try {
    wx.ready(() => {
      // wx.config注册成功的回调函数
      // 在此处可判断jsApiList是否注册成功
      alert("ready");
      wx.checkJsApi({
        jsApiList: ["chooseWXPay"],
        success: res => {
          alert(JSON.stringify(res));
        }
      });
    });
    wx.error(function(res) {
      alert("config err:" + JSON.stringify(res));
    });
  } catch (err) {
    alert("校验失败,重新校验");
    configApi();
  }
};

function urlencode(str) {
  str = (str + "").toString();
  return encodeURIComponent(str)
    .replace(/!/g, "%21")
    .replace(/'/g, "%27")
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/\*/g, "%2A")
    .replace(/%20/g, "+");
}

function getAppid() {
  return config.appid;
}

export const getQueryString = paraName => {
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return null;
  } else {
    return null;
  }
};

//时间戳转日期 年月日
export const formatDateTime = (inputTime, type, Spacer = "-") => {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  //return y + '-' + m + '-' + d;

  if (type == 1) {
    return m + "/" + d + " " + h + ":" + minute;
  } else if (type == 2) {
    return y + "-" + m + "-" + d + " " + h + ":" + minute;
  } else if (type == 3) {
    return y + Spacer + m + Spacer + d;
  } else {
    return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
  }
};

export const formatDate = (source, format, ignoreType) => {
  const preFormate = format;
  const preSource = source;
  source = isNaN(source) ? source : new Date(source);
  var o = {
    "M+": source.getMonth() + 1, // 月份
    "d+": source.getDate(), // 日
    "H+": source.getHours(), // 小时
    "m+": source.getMinutes(), // 分
    "s+": source.getSeconds(), // 秒
    "q+": Math.floor((source.getMonth() + 3) / 3), // 季度
    "f+": source.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (source.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  if (
    (preFormate == "yyyy-MM-dd HH:mm" || preFormate == 'yyyy-MM-dd HH:mm:ss') &&
    ignoreType == "sameYear" &&
    preSource.getFullYear() == new Date().getFullYear()
  ) {
    return format.slice(5, format.length);
  }
  return format;
};

export const getTimeString = timeInSeconds => {
  var hour = Math.floor(timeInSeconds / 60 / 60);
  if (hour < 10) {
    hour = "0" + hour;
  }
  var minute = Math.floor((timeInSeconds - hour * 60 * 60) / 60);
  if (minute < 10) {
    minute = "0" + minute;
  }
  return hour + ":" + minute;
};

export const formatMinute = time => {
  time = Math.round(time);
  if (time < 60) return time + "秒";
  else {
    let s = time % 60;
    return Math.floor(time / 60) + "分" + (s ? s + "秒" : "");
  }
};

export const formatMinuteNew = time => {
  time = Math.round(time);
  if (time < 60) return time + "秒";
  else {
    let s = time % 60;
    return Math.floor(time / 60) + "分" + s + "秒";
  }
};

export const formatMinuteText = time => {
  time = Math.round(time);
  if (time < 60) return time + "秒";
  else if (time < 3600) {
    let s = time % 60;
    return Math.floor(time / 60) + "分钟" + (s ? s + "秒" : "");
  } else {
    let s = Math.floor(time % 60);
    let m = Math.floor((time / 60) % 60);
    return (
      Math.floor(time / 3600) +
      "小时" +
      (m ? m + "分" : "") +
      (s ? s + "秒" : "")
    );
  }
};

export const timestampToDate = (ctime, len = 3) => {
  let returnStr = "";
  // 天数位
  // let day = Math.floor(ctime / 3600 / 24);
  // let dayStr = day.toString();
  // if (dayStr.length == 1) dayStr = '0' + dayStr;
  if (len == 3 || ctime > 60 * 60) {
    // 小时位
    let hr = Math.floor(ctime / 3600);
    let hrStr = hr.toString();
    if (hrStr.length == 1) hrStr = "0" + hrStr;
    returnStr = hrStr;
    // 分钟位
    let min = Math.floor((ctime / 60) % 60);
    let minStr = min.toString();
    if (minStr.length == 1) minStr = "0" + minStr;
    returnStr += ":" + minStr;
    // 秒位
    let sec = Math.floor(ctime % 60);
    let secStr = sec.toString();
    if (secStr.length == 1) secStr = "0" + secStr;
    returnStr += ":" + secStr;
    return returnStr;
  } else {
    let sec = ctime % 60;
    let min = parseInt((ctime / 60) % 60);
    if (min < 10) {
      min = "0" + min;
    }
    if (sec < 10) {
      sec = "0" + sec;
    }
    if (ctime) {
      return min + ":" + sec;
    } else {
      return "00:00";
    }
  }
};

//获取地理
export const getDistance = (lng1, lat1, lng2, lat2) => {
  var radLat1 = rad(lat1);
  var radLat2 = rad(lat2);
  var a = radLat1 - radLat2;
  var b = rad(lng1) - rad(lng2);
  var s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  s = s * 6378.137; //地球半径
  s = Math.round(s * 10000) / 10;
  return s;
};

function rad(d) {
  return (d * Math.PI) / 180.0;
}

// 深拷贝
export const deepClone = obj => {
  return dC(obj);
};
function dC(obj) {
  let result;
  // 判断是否为简单类型
  if (typeof obj === "object") {
    result = Array.isArray(obj) ? [] : {}; // 判断是对象还是数组
    for (let i in obj) {
      result[i] = typeof obj[i] === "object" ? dC(obj[i]) : obj[i];
    }
  } else {
    // 简单类型 直接 == 赋值
    result = obj;
  }
  return result;
}

// 进入答题离开答题记录状态
export const updateJoinStatus = (update_type, qid) => {
  let parm = {
    access_token: getToken(),
    qid,
    update_type
  };
  questionOnly
    .post(api.question.updateJoinStatus, parm)
    .then(() => {})
    .catch(function(errors) {
      alert("errors" + errors);
    });
};

// 生成随机数字
export const randomString = count => {
  count = count || 32;
  var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
    a = t.length,
    n = "";
  for (let i = 0; i < count; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n;
};

export const requestAuth = redirectURI => {
  let state = randomString(16);
  wemeet.permission
    .requestAuth({
      sdkId: api.sdkId,
      corpId: 213872664,
      redirectURI: redirectURI,
      state
    })
    .then(() => {})
    .catch(err => {
      Toast(err);
    });
};

// 获取鉴权所需config
export const getConfig = () => {
  return new Promise((resolve, reject) => {
    questionOnly
      .post(api.question.getConfig, {
        ref_url: window.location.href,
        access_token: getToken(),
        app_type: api.test ? 1 : 0
      })
      .then(res => {
        if (res.sta == 0) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
      })
      .catch(function(err) {
        reject(err);
      });
  });
};

// 身份过期重新登陆
export const reLogin = (type, url) => {
  if (wemeet.app.isTMWebview()) {
    // let getVipTime = localStorage.getItem('getVipTime');
    let fail_count = parseInt(localStorage.getItem("fail_count")) || 0;
    // Toast('fail_count:' + fail_count)
    if (fail_count >= 5) {
      Dialog.alert({
        message: "登录失败，请关闭腾讯会议重新启动后进入应用"
      }).then(() => {
        localStorage.removeItem("fail_count");
      });
      return;
    }
    let targetUrl = url ? url : "/login";
    // Dialog.alert({message: getToken()});
    if (type) {
      let data = localStorage.getItem(type) || "";
      if (type === "template_id") {
        localStorage.setItem("loginTip", 1);
      }
      if (type === "sync") localStorage.setItem("loginTip", 4);
      localStorage.setItem(type, data);
    }
    if (localStorage.getItem("bind_status") == 1) {
      localStorage.removeItem("token");
      localStorage.removeItem("bind_status");
    }
    localStorage.setItem("fail_count", fail_count + 1);
    if (localStorage.getItem("load_time")) localStorage.removeItem("load_time");
    // if(getToken() && localStorage.getItem('bind_status') != 1) {
    //   requestAuth("https://" + api.hostName + ".xiaoxiaodati.com/" + targetUrl)
    //   return;
    // }
    // if(getVipTime) localStorage.setItem('getVipTime', getVipTime)
    requestAuth("https://" + api.hostName + ".xiaoxiaodati.com" + targetUrl);
  } else {
    localStorage.clear();
    if (localStorage.getItem("token")) localStorage.removeItem("token");
    jumpWxAuth();
  }
};

// 设置分享信息
export const setShareInfo = (
  shareEnable = true,
  desc = "知识培训、趣味问答支持各种场景在线答题"
) => {
  if (wemeet.app.isTMWebview()) {
    return new Promise((resolve, reject) => {
      let meet_name = localStorage.getItem("meet_name") || "立吉答题用户";
      window.wemeet.app
        .setShareOpenAppConfig({
          shareEnable: shareEnable, // webview顶部栏分享按键是否可见
          title: meet_name + "邀请您使用立吉答题", //IM消息卡片标题
          desc: desc, // IM消息卡片描述
          notifyDesc: "", //会中消息通知文案
          confirmBtnText: "确认", //会中消息通知确认按钮文案
          pcUrl: window.location.href, //桌面端分享url
          mobileUrl: window.location.href //移动端分享url
        })
        .then(() => {
          resolve();
        })
        .catch(err => {
          Toast("分享设置失败");
          reject(err);
        });
    });
  }
};

export const filterPunctuation = str => {
  return str.replace(/[\s\.;,。；、，·•]+/g, "");
};

// 鉴权
export const getPremissing = (url = "") => {
  // Toast('获取鉴权中')
  return new Promise((resolve, reject) => {
    questionOnly
      .post(api.question.getConfig, {
        ref_url: window.location.href,
        access_token: getToken(),
        app_type: api.test ? 1 : 0
      })
      .then(res => {
        if (res.sta == 0) {
          let config = {
            sdkId: api.sdkId,
            corpId: "213872664",
            signature: res.data.signature,
            nonceStr: res.data.nonce_str,
            timestamp: res.data.timestamp
          };
          window.wemeet.permission
            .agentConfig(config)
            .then(() => {
              resolve();
            })
            .catch(err => {
              setTimeout(() => {
                if (localStorage.getItem("userInfo"))
                  localStorage.removeItem("userInfo");
                if (localStorage.getItem("token"))
                  localStorage.removeItem("token");
                // Dialog.alert({
                //   message: "鉴权失败，重新跳转"
                // });
                reLogin("", url);
              }, 1000);
            });
        } else {
          reject(res);
        }
      })
      .catch(function(err) {
        reject(err);
      });
  });
};

export const trim = str => {
  if (typeof str == "string") return str.replace(/(^\s*)|(\s*$)/g, "");
  else return str;
};

export const copyTemp = data => {
  return new Promise(resolve => {
    let param = {
      qid: data.qid,
      access_token: getToken(),
      copy_type: 1,
      temp_id: data.temp_id,
      version_code: 1,
      xcx_version: "1.0.0"
    };
    questionOnly.post("/xcx/ques/v1/copy_create", param).then(res => {
      if (res.sta == 0) {
        resolve(res.data);
      } else {
        Toast(res.msg);
      }
    });
  });
};

// 判断是否是移动端
export const isMobile = () => {
  var ua = navigator.userAgent.toLowerCase();
  var bIsIpad = ua.match(/ipad/i) == "ipad";
  var bIsIphoneOs = ua.match(/iphone os/i) == "iphone os";
  var bIsMidp = ua.match(/midp/i) == "midp";
  var bIsUc7 = ua.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = ua.match(/ucweb/i) == "ucweb";
  var bIsAndroid = ua.match(/android/i) == "android";
  var bIsCE = ua.match(/windows ce/i) == "windows ce";
  var bIsWM = ua.match(/windows mobile/i) == "windows mobile";
  var bIsHarmony = ua.indexOf('harmony') != -1;
  var bIsPhone = ua.indexOf('phone') !== -1;
  var bIsMobile = ua.indexOf('mobile') !== -1;
  if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsHarmony || bIsPhone || bIsMobile) ){
      return false;
  } else return true;
};

export const isWeixin = () => {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    if(ua.indexOf('wxwork') == -1) {
      return true; 
    }else {
      return false; 
    }
  } else {
    return false;
  }
};

// 乘法
export const accMul = (arg1, arg2) => {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  if (s1.split(".")[1]) {
    m += s1.split(".")[1].length;
  }
  if (s2.split(".")[1]) {
    m += s2.split(".")[1].length;
  }
  return (
    (s1.replace(".", "") * 1 * (s2.replace(".", "") * 1)) / Math.pow(10, m)
  );
};

export const tabIcon = [
  {
    active: require("../assets/icon/tab_cj_sele.png"),
    inactive: require("../assets/icon/tab_cj.png")
  },
  {
    active: require("../assets/icon/tab_question_selected.png"),
    inactive: require("../assets/icon/tab_question.png")
  }
];

export const showModelTips = (message, obj) => {
  obj = obj ? obj : {};
  Dialog.alert({
    title: obj.title ? obj.title : "温馨提示",
    message,
    confirmButtonColor: obj.confirmColor || "#1890ff",
    confirmButtonText: obj.confirmText || "我知道了"
  }).then(() => {
    if (obj.okCb) {
      obj.okCb();
    }
  });
};

// 获取移动端跳转至小程序连接
export const getWxUrl = (
  path = "pages/createdefault/createdefault",
  scene = "",
  type = "" // type: 等于1的时候  不需要token
) => {
  return new Promise(resolve => {
    if (!type && !getToken()) {
      return reLogin();
    }
    let param = {
      path,
      scene
    };
    if (type) {
      param.type = type;
    } else {
      param.access_token = getToken();
    }
    questionOnly.get("/xcx/ques/v1/schema", param).then(res => {
      if (res.sta == 0) {
        resolve(res.data.scheme);
      } else {
        Toast(res.msg);
      }
    });
  });
};

// 验证当前登录状态
export const verifyAuth = () => {
  return new Promise(resolve => {
    if (!getToken()) resolve(false);
    questionOnly
      .get("/xcx/ques/v1/owner", { access_token: getToken(), loadingMsg: 'no' })
      .then(res => {
        if (res.sta == 0) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
  });
};

export const getAuth = () => {
  return new Promise(resolve => {
    if (!getToken()) resolve(false);
    questionOnly
      .get("/xcx/ques/v1/owner", { access_token: getToken() })
      .then(res => {
        if (res.sta == 0) {
          resolve(res.data);
        } else {
          resolve(false);
        }
      });
  });
};
// 获取小程序答题主页二维码
export const getDetailWxCode = (qid, mode = 8) => {
  return new Promise(resolve => {
    questionOnly
      .get("/xcx/ques/v1/qrcode", {
        qid,
        mode,
        is_hyaline: 0,
        with_bg: 0,
        access_token: getToken() || ""
      })
      .then(res => {
        if (res.sta == 0 && res.data.url) {
          resolve(res.data.url);
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
  });
};
// 获取缓存状态
export const getCacheStatus = (qid, type = 0, rec_staging_id = "") => {
  return new Promise(resolve => {
    questionOnly
      .get("/xcx/ques/v1/submit/staging", {
        qid,
        type,
        rec_staging_id,
        access_token: getToken()
      })
      .then(res => {
        if (res.sta == 0) {
          resolve(res.data.staging_data);
        } else {
          Toast(res.msg);
        }
      });
  });
};

// 更新缓存状态
export const changeCacheStatus = (qid, rec_staging_id) => {
  return new Promise(resolve => {
    questionOnly
      .post("/xcx/ques/v1/submit/staging", {
        qid,
        type: 2,
        rec_staging_id,
        access_token: getToken()
      })
      .then(res => {
        if (res.sta == 0) {
          resolve();
        } else {
          Toast(res.msg);
        }
      });
  });
};

// 处理登录code
export const handleCode = code => {
  return new Promise(resolve => {
    questionOnly
      .post(api.question.login, { code: code })
      .then(res => {
        if (res.sta == 0) {
          localStorage.setItem("token", res.data.access_token);
          handleZI(res.data.mp_openid)
          resolve("login success");
        } else if (res.sta == -1) {
          alert(res.msg);
        }
      })
      .catch(function(errors) {});
  });
};

// 根据auth_code换取绑定/未绑定的token
export const getBindToken = code => {
  return new Promise(resolve => {
    questionOnly
      .post("/xcx/ques/v1/meeting/login", {
        auth_code: code,
        app_type: api.test ? 1 : 0
      })
      .then(res => {
        if (res.sta == 0) {
          handleZI(res.mp_openid)
          resolve(res.data);
        } else if (res.sta == -1) {
          // Toast('校验失败0')
          alert(res.msg);
        }
      })
      .catch(function(errors) {
        // Dialog.alert({message: JSON.stringify(errors)})
        // Toast(JSON)
      });
  });
};

// 敏感词校验
export const checkWords = content => {
  return new Promise(resolve => {
    questionOnly
      .post("/xcx/ques/v1/check", {
        content,
        access_token: getToken()
      })
      .then(res => {
        if (res.sta == 0) {
          resolve(res);
        } else if (res.sta == -1) {
          alert(res.msg);
        }
      })
      .catch(function(errors) {
        // Dialog.alert({message: JSON.stringify(errors)})
        // Toast(JSON)
      });
  });
};

export const initWebSocket = () => {
  let cid = store.state.meetingInfo.meet_id;
  const wsurl =
    api.baseUrl.replace("https:", "wss:") +
    "/xcx/ques/v1/radio/event" +
    "?cid=" +
    cid;
  let socket = new WebSocket(wsurl);
  socket.onmessage = websocketonmessage;
  socket.onopen = websocketonopen;
  socket.onerror = websocketonerror();
};

function websocketonmessage(e) {
  if (e.data) {
    let { expend_time, time_limit, timer_type, status } = JSON.parse(e.data);
    store.commit("changeMeetingInfo", {
      expend_time,
      time_limit,
      timer_type,
      status
    });
    if (router.history.current.name != "timer" && status != 2) {
      router.push({
        name: "timer"
      });
    }
  }
}

function websocketonopen(e) {
}

function websocketonerror(e) {
}

export const getCurMeeetInfo = meet_id => {
  let data = {
    access_token: getToken(),
    meet_id: meet_id
  };
  return new Promise(resolve => {
    questionOnly.get("/xcx/ques/v1/meeting/timer/status", data).then(res => {
      if (res.sta == 0) {
        resolve(res);
      } else {
        Dialog.alert({
          message: "获取会议信息失败" + JSON.stringify(data)
        });
      }
    });
  });
};

export const getUTCTime = () => {
  let d1 = new Date();
  let d2 = new Date(
    d1.getUTCFullYear(),
    d1.getUTCMonth(),
    d1.getUTCDate(),
    d1.getUTCHours(),
    d1.getUTCMinutes(),
    d1.getUTCSeconds()
  );
  return Date.parse(d2) / 1000 + 28800;
};

export const backStep = () => {
  router.go(-1);
};

// 数据统计
export const adClickData = (type, name) => {
  let data = {
    ...type == 'h5_draw_adv' ? {} : {access_token: getToken()},
    action_type: type,
    name,
    source: 2
  };
  questionOnly.post("/xcx/ques_web/v3/stat_point", data).then(res => {
    if (res.sta != 0) {
      Toast(res.msg);
    }
  });
};

// 数据按人统计
export const adClickReport = (type, name) => {
  let data = {
    access_token: getToken(),
    action_type: type,
    source: 2, // 来源，0: 小程序、 1: PC、2:H5
    ...name ? { name } : {}
  };
  questionOnly.post("/xcx/ques/v1/stat/user_point", data).then(res => {
    if (res.sta != 0) {
      Toast(res.msg);
    }
  });
};

// 付费认证归因
export const vipClick = (type, name, isType) => {
  let data = {
    access_token: getToken(),
    action_type: type,
    source: 2, // 0 小程序 1 pc  2 h5
    ...(name ? { name } : {}),
    ...isType? { type: 1} : {}
  };
  questionOnly.post("/xcx/ques/v1/stat/action", data).then(res => {
    if (res.sta != 0) {
      Toast(res.msg);
    }
  });
};

// 错题本付费归因
export const wrongbookClick = (action_type, name, type) => {
  let data = {
    access_token: getToken(),
    action_type: action_type,
    source: 2, // 0 小程序 1 pc  2 h5
    ...(name ? { name } : {}),
    ...type ? { type } : {},
    loadingMsg: 'no'
  };
  questionOnly.post("/xcx/ques/v1/book/stat", data).then(res => {
    if (res.sta != 0) {
      Toast(res.msg);
    }
  });
};

// 检查网络状态
export const checkNetWork = () => {
  return new Promise(resolve => {
    if (window.navigator.onLine) {
      resolve();
    } else {
      Toast("网络异常，请求失败");
    }
  });
};

export const getLocalTime = () => {
  return new Date().getTime() + (Number(localStorage.getItem("differTimer")) || 0);
};

export const getLists = lists => {
  for (const i in lists) {
    let item = lists[i];
    if (item.type == 0 || item.type == 1 || item.type == 2) {
      let correct = [];
      for (const j in item.options) {
        if (item.options[j].right == 1) correct.push(item.options[j].letter);
      }
      item.correct = correct.join("");
    }
  }
  return lists;
};

export const goWebWay = () => {
  getPremissing().then(() => {
    wemeet.ui
      .openExternalPage({
        url: "https://xiaoxiaodati.com",
        success: () => {},
        fail: err => {
          Toast("falil:" + JSON.stringify(err));
        }
      })
      .catch(err => {
        Toast("err:" + JSON.stringify(err));
      });
  });
};

// 联系客服是否可跳转
export const showServiceAble = () => {
  return new Promise((resolve, reject) => {
    if(wemeet.app.isTMWebview()) {
      resolve(true)
    }else {
      _ZHINI({ action: 'showPanel' })
    }
    // const isWeChat = /micromessenger/i.test(navigator.userAgent);
    // const isMobile = /mobile/i.test(navigator.userAgent);
    // const isWeChatMobile = isWeChat && isMobile;
    // if (isWeChatMobile) {
    //   window.location.href =
    //     "https://work.weixin.qq.com/kfid/kfc811b2f153c6ebc30?enc_scene=ENC7XpxTv49cGR1cvTBvZR8Xt7kwn9EQoWVga4c8LaKBWPTTFsefzMJDKzdqDCFVYwvbc";
    // } else {
    //   resolve(true);
    // }
  });
};

// 发送验证码
export const getCode = phone => {
  return new Promise((resolve, reject) => {
    questionOnly
      .get("/xcx/ques/v1/phone/valid", {
        access_token: getToken(),
        phone
      })
      .then(res => {
        if (res.sta === 0) {
          resolve(true);
        } else {
          reject(res.msg || "手机号格式不正确，请重新输入");
        }
      });
  });
};

// 校验手机号验证码
export const checkCode = sendData => {
  return new Promise((resolve, reject) => {
    questionOnly
      .post("/xcx/ques/v1/phone/valid", {
        access_token: getToken(),
        ...sendData
      })
      .then(res => {
        if (res.sta === 0) {
          resolve(res);
        } else {
          reject(res.msg || "验证码错误，请重新输入");
        }
      });
  });
};

export const jumpWrongList = (self) =>{
  if (window.location.href.includes("cert") || window.location.href.includes("localhost")) { // 同一域名直接跳转就好了
    self.$router.push({
      name: "wrongbooklist"
    });
  }else {
    let client_id = localStorage.getItem('client_id')
    const baseUrl = window.location.href.includes('test') ? 'https://cert.xiaoxiaodati.com/test/' : 'https://cert.xiaoxiaodati.com/';
    let url = baseUrl + 'wrongbooklist?ut=' + getToken()+ '&client_id=' + client_id;
    if(wemeet.app.isTMWebview()) {
      url = url + '&from_type=1' // 腾讯会议跳转的
    }
    window.location.href = url;
  }
}

export const jumpVip = (self) =>{
  if (window.location.href.includes("cert") || window.location.href.includes("localhost")) { // 同一域名直接跳转就好了
    self.$router.push({
      name: "vip"
    });
  }else {
    let client_id = localStorage.getItem('client_id')
    const baseUrl = window.location.href.includes('test') ? 'https://cert.xiaoxiaodati.com/test/' : 'https://cert.xiaoxiaodati.com/';
    const url = baseUrl + 'vip?ut=' + getToken() + '&client_id=' + client_id;
    window.location.href = url;
  }
}

// 获取各种二维码
export const getQrcodeFn = (param = {}) => {
  return new Promise((resolve)=> {
    let { qid,mode, is_hyaline , with_bg, line_color = '' } = param || {}
    questionOnly
    .get("/xcx/ques/v1/qrcode", { 
      access_token: getToken(),
      qid,
      mode, // 小程序码 | 二维码
      is_hyaline,  // 获取透明小程序码
      with_bg,  // 只要小程序码，不需要下方文字
      loadingMsg: 'no',
      ...line_color ? { line_color } : {}
    })
    .then(res => {
      if (res.sta == 0) {
        resolve(res.data)
      } else {
        Toast(res.msg || "请求失败");
      }
    });
  })
}

export const handleZI = (mp_openid) => {
  localStorage.setItem('client_id', mp_openid || '')
  _ZHINI({
    action: "init", 
    client_id: mp_openid,
  });
}

export const enQues = (str) => {
  let code = ''
  if(str) {
    let fillCode = decrypt(str);
    if(fillCode) {
      fillCode = fillCode.split('_')[0];
      let t_start = parseInt(new Date().getTime() / 1000);
      fillCode = fillCode + '_' + t_start;
      return encrypt(fillCode)
    }else {
      return ''
    }
  }
  return code
}


// WEBPACK FOOTER //
// ./src/utils/common.js